module.exports = __webpack_public_path__ + "static/PP8s-124b6c8eb136719b60595a8f4cc248f4.jpg";